<template>
  <div>
    <div class="selectPlan">
      <div class="switchQuote">
        <div class="switchQuote__container">
          <input type="radio" id="tpl" value="tpl" @change="switchPlan" v-model.lazy="switchValue_">
          <label for="tpl">{{ $t('renew_change_policy_tpl_current') }}</label>
        </div>
        <div class="switchQuote__container">
          <input type="radio" id="od" value="comp" @change="switchPlan" v-model.lazy="switchValue_">
          <label for="od">{{ $t('renew_change_policy_comp') }}
            <div class="selectPlan__discount-badge" v-if="offerText">&lrm;
              {{ offerText }}
            </div>
            <div class="selectPlan__discount-badge" v-if="!offerText && showOdDiscount && odInfo.discount">&lrm;
              {{ odInfo.discount }}% {{ $t('renew.label.off') }}
            </div>
          </label>
        </div>
      </div>
      <div class="selectPlan__customize">
        <template v-if="isTPL">
          <template v-if="isFullPaymentExperiment || isMonthlyPaymentExperiment">
            <p v-if="isFullPaymentExperiment" class="selectPlan__upgrade-desc selectPlan__upgrade-desc--green">
              {{ $t('renew.upgrade.full.without_discount', { price: odInfo.price - tplInfo.price }) }}
            </p>
            <p v-if="isMonthlyPaymentExperiment" class="selectPlan__upgrade-desc selectPlan__upgrade-desc--green">
              {{ $t('renew.upgrade.monthly.without_discount', { price: experimentPriceMonth }) }}
            </p>
          </template>
          <p v-else class="selectPlan__upgrade-desc selectPlan__upgrade-desc--black">
            {{ $t('renew_car_change_plan_od_upgrade_desc') }}
          </p>
          <ul class="selectPlan__customize-list">
            <li v-for="item in includes"
                :class="{ included: item.isTpl, 'not-included': !item.isTpl }"
                :key="item.id">
              {{ item.name }}
            </li>
          </ul>
        </template>
        <template v-else>
          <p class="selectPlan__upgrade-desc selectPlan__upgrade-desc--black">
            {{ $t('renew_policy_number_will_change') }}
          </p>
          <ul class="selectPlan__customize-list">
            <li v-for="item in includes"
                class="included"
                :key="item.id">
              <span>{{ item.name }}</span>
              <span v-if="item.optional" class="selectPlan__badge">
                  {{ $t('renew.label.addon') }}
                </span>
            </li>
          </ul>
        </template>
        <div v-if="isTPL" class="selectPlan__price selectPlan__price_base">
          <span class="selectPlan__price_base_bold">{{
              $t('renew_qar', { price: this.$options.filters.splitNumber(price) })
            }}</span>
        </div>
        <template v-if="!isTPL">
          <div class="selectPlan__price">
            <div v-if="showOdDiscount && isFullPaymentExperiment" class="selectPlan__price_old">
              <span class="selectPlan__price_old_bold">{{ $t('renew.price.qar') }}</span>&nbsp;
              <span class="selectPlan__price_old_regular">{{
                  this.$options.filters.splitNumber(fullPriceFromMinOdScheme)
                }}</span>
            </div>
            <div class="selectPlan__price_base">
              <template v-if="isMonthlyPaymentExperiment">
                  <span class="selectPlan__price_base_regular">{{ $t('renew.price.from') }}</span>&nbsp;
                  <span class="selectPlan__price_base_bold">{{ $t('renew_qar', { price: installmentPrice }) }}</span>&nbsp;
                  <span class="selectPlan__price_base_regular">{{ $t('renew.upgrade.monthly_name') }}</span>
                  <div class="selectPlan__installment-experiment">
                    <i @click="learnMore">
                      {{ $t('renew.learn_more') }}
                    </i>
                  </div>
              </template>
              <template v-else>
                <span class="selectPlan__price_base_regular">{{ $t('renew.price.from') }}</span>&nbsp;
                <span class="selectPlan__price_base_bold">{{ $t('renew_qar',
                    { price: this.$options.filters.splitNumber(price) })
                  }}
                </span>
              </template>
            </div>
          </div>
          <i v-if="switchValue_ ==='comp'" class="selectPlan__installment">
            <div v-if="!isMonthlyPaymentExperiment">
              {{ $t('select_plan_installment', { installment: installmentPrice }) }}
              <i @click="learnMore">
                {{ $t('renew.learn_more') }}
              </i>
            </div>
          </i>
        </template>
      </div>
    </div>
    <BaseButton @click.prevent="$emit('submit', switchValue_)"/>
    <BasePopupWrapper
        v-if="isInstallmentsShown"
        :popupBig="true"
        @close="isInstallmentsShown = false"
    >
      <div class="installment-select-plan__popup">
        <h3>{{ $t('qic_installment_popup.title') }}</h3>
        <h4>{{ $t('qic_installment_popup.heading_1') }}</h4>
        <p>{{ $t('qic_installment_popup.text_1_1') }}</p>
        <h4>{{ $t('qic_installment_popup.heading_2') }}</h4>
        <p>{{ $t('qic_installment_popup.text_2_1') }}</p>
        <p>{{ $t('qic_installment_popup.text_2_2') }}</p>
        <p>{{ $t('qic_installment_popup.text_2_3') }}</p>
        <h4>{{ $t('qic_installment_popup.heading_3') }}</h4>
        <p>{{ $t('qic_installment_popup.text_3_1') }}
          <a href="/assets/pdf/Motor_Terms_And_Conditions_Installment.pdf" target="_blank">
            {{ $t('qic_installment_popup.text_3_1_link') }}
          </a></p>
        <p>{{ $t('qic_installment_popup.text_3_2') }}</p>
      </div>
      <template v-slot:button>
        <base-button symbol="no" class="btn-second btn-second_medium" @click="isInstallmentsShown = false">
          {{ $t('qic_close') }}
        </base-button>
      </template>
    </BasePopupWrapper>
  </div>
</template>

<script>
import { BasePopupWrapper } from 'qic-components'
import { MONTH_PAYMENT_EXPERIMENT, FULL_PAYMENT_EXPERIMENT } from '@/constants/experimentNames'

export default {
  name: 'MotorChangeTplForm',
  emits: ['submit', 'switchPlan', 'clickLearnMore'],
  components: {
    BasePopupWrapper
  },
  props: {
    switchValue: {
      type: String,
      default: 'tpl'
    },
    tplInfo: {},
    odInfo: {},
    odSchemes: { type: Array },
    tplSchemes: { type: Array },
    offerText: String
  },
  data () {
    return {
      switchValue_: this.switchValue,
      isInstallmentsShown: false,
      includesInfo: [
        { text: this.$t('renew_car_change_plan_tpl'), tpl: true, comp: true, id: '01201' },
        { text: this.$t('renew_car_change_plan_passenger'), tpl: true, comp: true, id: '01002' },
        { text: this.$t('renew_car_change_plan_damage'), tpl: false, comp: true, id: '01000' },
        { text: this.$t('renew_car_change_plan_roadside'), tpl: false, comp: true, id: '01012' },
        { text: this.$t('renew_car_change_plan_repairs'), tpl: false, comp: true, id: '01008' },
        { text: this.$t('renew_car_change_plan_deprecation'), tpl: false, comp: true, id: '01029' },
        { text: this.$t('renew_car_change_plan_benefit'), tpl: false, comp: true, id: '' },
        { text: this.$t('renew_car_change_plan_offroad'), tpl: false, comp: true, id: '01012' }
      ]
    }
  },
  computed: {
    installmentPrice () {
      return this.isTPL ? this.tplInfo.monthlyPrice : this.odInfo.monthlyPrice
    },
    price () {
      return this.isTPL ? this.tplInfo.price : this.odInfo.price
    },
    isMonthlyPaymentExperiment () {
      return this.$store.state.typeOfPayment === MONTH_PAYMENT_EXPERIMENT
    },
    isFullPaymentExperiment () {
      return this.$store.state.typeOfPayment === FULL_PAYMENT_EXPERIMENT
    },
    experimentPriceMonth () {
      return this.odInfo.monthlyPrice
    },
    showOdDiscount () {
      return this.odInfo.discount > 0
    },
    fullPriceFromMinOdScheme () {
      return this.getMinPriceOdScheme()?.fullPrice
    },
    isTPL () {
      return this.switchValue_ === 'tpl'
    },
    includes () {
      if (this.isEmptyArray(this.tplSchemes) || this.isEmptyArray(this.odSchemes)) {
        return
      }
      const mergedIncludes = [...this.getTplIncludes(), ...this.getOdIncludes()]
      mergedIncludes.sort((a, b) => (a.optional && !b.optional ? 1 : -1))

      const uniqueIncludes = new Map()

      mergedIncludes.forEach(item => {
        if (!uniqueIncludes.has(item.id) || item.isTpl) {
          uniqueIncludes.set(item.id, item)
        }
      })
      return [...uniqueIncludes.values()]
    }
  },
  methods: {
    isEmptyArray (array) {
      return Array.isArray(array) && array.length === 0
    },
    learnMore () {
      this.isInstallmentsShown = true
      this.$emit('clickLearnMore')
    },
    switchPlan () {
      this.$emit('switchPlan', this.switchValue_)
    },
    getMinPriceOdScheme () {
      return this.odSchemes.reduce((minScheme, scheme) =>
        minScheme.price < scheme.price ? minScheme : scheme
      )
    },
    getOdIncludes () {
      const { included, ids } = this.getMinPriceOdScheme()
      const idsWithParams = this.extendObjectsWithParams(ids, { optional: true, isTpl: false })
      const includedWithParams = this.extendObjectsWithParams(included, { isTpl: false })
      return [...idsWithParams, ...includedWithParams]
    },
    getTplIncludes () {
      const includes = this.tplSchemes[0]?.included
      return this.extendObjectsWithParams(includes, { isTpl: true })
    },
    extendObjectsWithParams (array, params) {
      if (this.isEmptyArray(array)) {
        return []
      }
      return array.map(item => ({ ...item, ...params }))
    }
  },
  watch: {
    switchValue (newValue) {
      this.switchValue_ = newValue
    }
  }
}
</script>

<style scoped lang="scss">
.selectPlan {
  position: relative;

  &__price_base {
    @media (max-width: 550px) {
      font-size: 19px;
    }
  }

  &__installment-experiment {
    font-size: 14px;
    line-height: 24px;
    display: block;
    font-weight: 400;
    color: rgba(82, 108, 130, 0.8);
    align-self: flex-end;
    @media (max-width: 550px) {
      line-height: 24px !important;
      font-size: 12px;
    }

    i {
      color: #5927FF;
      cursor: pointer;
      margin-inline-start: 12px;
    }
  }

  &__customize-list li {
    grid-template-columns: auto 1fr auto;
  }

  .switchQuote input:checked + label {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.10);
    border: none;
    border-radius: 12px;
    color: black;
  }

  .switchQuote input + label:hover {
    color: inherit;
  }

  &__upgrade-desc {
    &--green {
      color: #85C271;
      text-align: center;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      @media (max-width: 550px) {
        font-size: 16px;
        line-height: normal;
      }
    }

    &--black {
      color: black;
    }
  }
}
</style>
